import Api from 'services/Api';
import _ from 'lodash';

// Mutation Types
const mutationTypes = {
    UPDATE: 'UPDATE',
    RESULT: 'RESULT',
    RESET: 'RESET'
};

// Initial State
const state = {
    dateFrom: null,
    dateTo: null,
    interestRate: 0,
    principalAmount: 0,
    interestType: null,
    compoundFrequency: 1,
    interestAccrued: 0,
    aggregateRate: 0,
    noOfDays: 0,
    dailyRate: 0,
    theTotal: 0,
};

// Getters
const getters = {
    value: state => key => state[key],
};

/**
 * Gate the Api calls
 *
 * @param state
 * @returns {boolean}
 */
function calcInterestGate(state) {
    return (state.dateFrom !== null
        && state.dateTo !== null
        && state.dateTo > state.dateFrom
        && state.interestRate > 0
        && state.principalAmount > 0
        && state.interestType !== null);
}

// Actions
const actions = {
    update({ commit }, { key, value }) {
        commit(mutationTypes.UPDATE, { key, value });
    },
    calcInterest: _.debounce(({ dispatch, state }) => {
        if (calcInterestGate(state)) {
            return Api.miniCalculators.monetary.interest(state)
                .then(data => dispatch('result', data));
        }
    }, 500),
    result({ commit }, data) {
        commit(mutationTypes.RESULT, data);
    },
    reset({ commit }) {
        commit(mutationTypes.RESET);
    },
};

// Mutations
const mutations = {
    [mutationTypes.UPDATE](state, payload) {
        state[payload.key] = payload.value;
    },
    [mutationTypes.RESET](state) {
        state.dateFrom = null;
        state.dateTo = null;
        state.interestRate = 0;
        state.principalAmount = 0;
        state.interestAccrued = 0;
        state.interestType = null;
        state.compoundFrequency = 1;
        state.aggregateRate = 0;
        state.noOfDays = 0;
        state.dailyRate = 0;
        state.theTotal = 0;
    },
    [mutationTypes.RESULT](state, data) {
        state.interestAccrued = data.interest_accrued;
        state.aggregateRate = data.aggregate_rate;
        state.noOfDays = data.number_of_days;
        state.dailyRate = data.daily_rate;
        state.theTotal = data.total;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/mini/interest.js